<div style="background: #fff; border: solid #ccc 1px; padding: 3px; border-radius: 3px;">
    <div>

        <select (ngModelChange)="onChange($event)" [ngModel]="selectedState" class="form-select form-select-sm">
            <option>All</option>
            <option *ngFor="let item of workflow_statuses">
                {{item}}
            </option>
        </select>
    </div>
</div>